export enum ReportSheetType {
  Table = "Table",
  Chart = "Chart",
  ChartByDate = "ChartByDate",
  ComparisonChart = "ComparisonChart",
}
